// Decision logic for the "scan QR → add to basket" route (/cart/add/:uuidv4).
//
// The route component loads the product and hands the verdict here so the
// three outcomes stay testable without Preact:
//   - login        → anonymous; send to /login and bounce back afterwards
//   - not-found    → no product resolved (hidden, deleted, wrong uuidv4)
//   - product-page → cannot auto-add (variant must be chosen, or out of stock)
//   - add          → call userStore.addToCart with productId, qty 1
const cartAddDecision = ({ user, product }) => {
    if (!user || !user.id) {
        return { action: 'login' };
    }
    if (!product || !product.id) {
        return { action: 'not-found' };
    }
    const hasColors = Array.isArray(product.colors) && product.colors.length > 0;
    const hasSizes = Array.isArray(product.sizes) && product.sizes.length > 0;
    const inStock = typeof product.inStock === 'number' && product.inStock > 0;
    if (hasColors || hasSizes || !inStock) {
        return { action: 'product-page', uuidv4: product.uuidv4 };
    }
    return { action: 'add', productId: product.id };
};

// Deep link printed into the QR label. Mirrors the stock-pick label URL in
// components/dyrejournal/allProducts.js (hash router, http only on localhost).
const cartAddUrl = (hostname, uuidv4) => `${hostname === 'localhost' ? 'http' : 'https'}://${hostname}/#/cart/add/${uuidv4}`;

export { cartAddDecision, cartAddUrl };
